import { FindRecipientInfoType } from 'owa-recipient-common/lib/components/FindRecipientInfo';
import shouldShowHeaderFooterItem from '../utils/shouldShowHeaderFooterItem';
import { isStringNullOrWhiteSpace } from 'owa-strings';
import SuggestionsHeaderFooterInfo from '../components/SuggestionsHeaderFooterInfo';
import searchDirectory from './searchDirectory';
export default function getSuggestionProps(getViewState, getFindControl) {
    return {
        headerItemsProps: getHeaderItemProps(getViewState, getFindControl),
        footerItemsProps: getFooterItemProps(getViewState, getFindControl),
        shouldSelectFirstItem: function () {
            return !isStringNullOrWhiteSpace(getViewState().queryString);
        },
    };
}
function getHeaderItemProps(getViewState, getFindControl) {
    return [
        {
            renderItem: renderInfo(getViewState(), FindRecipientInfoType.TypeToSearch),
            shouldShow: shouldShowHeaderFooterItem(FindRecipientInfoType.TypeToSearch, getViewState()),
        },
        {
            renderItem: renderInfo(getViewState(), FindRecipientInfoType.SuggestedContacts),
            shouldShow: shouldShowHeaderFooterItem(FindRecipientInfoType.SuggestedContacts, getViewState()),
        },
        {
            renderItem: renderInfo(getViewState(), FindRecipientInfoType.UseAddress),
            shouldShow: shouldShowHeaderFooterItem(FindRecipientInfoType.UseAddress, getViewState()),
            onExecute: function () {
                if (getFindControl()) {
                    getFindControl().forceResolveSuggestion();
                }
            },
        },
    ];
}
function getFooterItemProps(getViewState, getFindControl) {
    return [
        {
            renderItem: renderInfo(getViewState(), FindRecipientInfoType.Searching),
            shouldShow: shouldShowHeaderFooterItem(FindRecipientInfoType.Searching, getViewState()),
        },
        {
            renderItem: renderInfo(getViewState(), FindRecipientInfoType.SearchDirectory),
            shouldShow: shouldShowHeaderFooterItem(FindRecipientInfoType.SearchDirectory, getViewState()),
            onExecute: function () {
                searchDirectory(getViewState, getFindControl());
            },
        },
        {
            renderItem: renderInfo(getViewState(), FindRecipientInfoType.TopNResults),
            shouldShow: shouldShowHeaderFooterItem(FindRecipientInfoType.TopNResults, getViewState()),
        },
    ];
}
function renderInfo(viewState, infoType) {
    return function () {
        return SuggestionsHeaderFooterInfo({
            queryString: viewState.queryString,
            numberOfResults: viewState.findResultSet.length,
            infoType: infoType,
        });
    };
}
//# sourceMappingURL=getSuggestionProps.js.map